import { useContext, useMemo } from 'react';
import { localStorage, SlideshowPreview } from 'dash-ui';
import {
  GetPropertyByIdQuery,
  useGetSlideshowMediaByPropertyQuery,
  useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery,
} from 'gql/generated.graphql';
import { PropertyPreviewParamsContext } from 'containers/properties/PropertyPreview/context/PropertyPreviewParamsContext';

function SlideShowPreview({
  property,
  isViewAsClient,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
  isViewAsClient?: boolean;
}) {
  const { params } = useContext(PropertyPreviewParamsContext);
  const { brokerId, portfolioFolderId } = params || {};
  const { data, loading } = useGetSlideshowMediaByPropertyQuery({
    variables: { propertyId: property._id },
    skip: isViewAsClient,
  });

  const { data: dataPublic, loading: loadingPublic } =
    useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery({
      variables: {
        propertyId: property._id,
        brokerId,
        portfolioFolderId: portfolioFolderId || undefined,
        password: localStorage.getPortfolioPassword(),
      },
      skip: !isViewAsClient || !brokerId,
    });

  const mediaFiles = useMemo(
    () =>
      data?.getSlideshowMediaByProperty ||
      dataPublic?.getPropertySlideshowMediaInPublicBrokerPortfolio ||
      [],
    [data, dataPublic]
  );

  const files = useMemo(
    () =>
      mediaFiles.map((item) => {
        const [file] = item.files;

        return {
          _id: item._id,
          name: file?.name,
          publicUrl: file?.publicUrl,
          type: file?.type,
          s3Key: file?.s3Key,
          thumbnailFileUrl: file?.thumbnailFileUrl,
        };
      }),
    [mediaFiles]
  );

  return (
    <SlideshowPreview
      w="100%"
      files={files}
      loading={loading || loadingPublic}
      totalCount={files.length}
      mainFileId={property.mainPropertyMediaFile?._id}
    />
  );
}

export default SlideShowPreview;
